import React from 'react';
import type { FC, ReactNode } from 'react';

import styles from './Panel.module.scss';

interface PanelProps {
    children: ReactNode;
    className?: string;
    bordered?: boolean;
}

export const Panel: FC<PanelProps> = ({ children, className, bordered = true }) => {
    const classes = [styles.panel, !bordered && styles.noBorder, className]
        .filter(Boolean)
        .join(' ');

    return <div className={classes}>{children}</div>;
};
